// TimelinesPopupContents.jsx

import React from 'react';

// Utilities
import { getTimelineViewTypeIconKey } from 'utilities/ViewTypeIcons';

// CSS
import './TimelinesPopupContents.css';

// Components
import PopupOption from 'components/popup/option/PopupOption';

/**
 * TimelinesPopupContents
 * 
 * Renders the popup component for the timeline related views.
 * 
 * @param {object[]} options - Views options to display.
 * @param {string|null} selectedDateTypeId - Selected date type id.
 * @param {function} onSelectOption - Handler for selecting an option.
 *  
 *
 * @returns {ReactNode} - TimelinesPopupContents.
 */
const TimelinesPopupContents = React.memo(({
    options = [],
    selectedDateTypeId = null,
    onSelectOption,
}) => {

  // ----- RENDER ----- //

  return (
        <div className="timelines-popup-contents-container">

            {options.map((option) => {

                const iconKey = getTimelineViewTypeIconKey(option?.type);
                const isSelected = option.id === selectedDateTypeId;

                return (
                    <PopupOption
                      key={option.id}
                      iconKey={iconKey}
                      label={option.label}
                      selected={isSelected}
                      onClick={() => onSelectOption?.(option.id)}
                    />
                );
            })}

        </div>
    );

});

// Dev Tools
TimelinesPopupContents.displayName = 'TimelinesPopupContents';

export default TimelinesPopupContents;
